import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(array: any[], predicate: (value: any) => boolean): any[] {
    if (!Array.isArray(array)) {
      return array;
    }
    return _.filter(array, predicate);
  }
}
